// Pointer drag-to-scroll for horizontal overflow rows (desktop mouse grab).
// Touch/trackpad keep native inertial scrolling — we only handle mouse.
const DRAG_THRESHOLD = 8

const bindProps = (row) => {
    let active = false
    let dragging = false
    let suppressClick = false
    let pointerId = null
    let startX = 0
    let startScroll = 0

    const stop = () => {
        if (!active) {
            return
        }

        active = false
        dragging = false

        window.removeEventListener('pointermove', onMove)
        window.removeEventListener('pointerup', onUp)
        window.removeEventListener('pointercancel', onUp)

        if (pointerId !== null && row.hasPointerCapture?.(pointerId)) {
            row.releasePointerCapture(pointerId)
        }

        pointerId = null
        row.classList.remove('is-dragging')
    }

    const onMove = (event) => {
        if (!active || event.pointerId !== pointerId) {
            return
        }

        const delta = event.clientX - startX

        if (!dragging) {
            if (Math.abs(delta) <= DRAG_THRESHOLD) {
                return
            }

            dragging = true
            suppressClick = true
            row.classList.add('is-dragging')

            // Capture only after threshold so plain clicks still hit the <a>
            try {
                row.setPointerCapture(pointerId)
            } catch {
                // ponytail: capture can throw if the gesture already ended
            }
        }

        event.preventDefault()
        row.scrollLeft = startScroll - delta
    }

    const onUp = (event) => {
        if (!active || event.pointerId !== pointerId) {
            return
        }

        stop()
    }

    row.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) {
            return
        }

        stop()

        active = true
        dragging = false
        suppressClick = false
        pointerId = event.pointerId
        startX = event.clientX
        startScroll = row.scrollLeft

        window.addEventListener('pointermove', onMove)
        window.addEventListener('pointerup', onUp)
        window.addEventListener('pointercancel', onUp)
    })

    row.addEventListener('dragstart', (event) => {
        event.preventDefault()
    })

    row.addEventListener(
        'click',
        (event) => {
            if (!suppressClick) {
                return
            }

            event.preventDefault()
            event.stopPropagation()
            suppressClick = false
        },
        true,
    )

    row.classList.add('is-dragscroll-bound')
}

export const dragScroll = {
    init() {
        document
            .querySelectorAll('.ck-video-overview__row:not(.is-dragscroll-bound)')
            .forEach(bindProps)
    },
}
